<template>
  <input ref="input">
</template>

<script setup>
import { ref, watch, onBeforeUnmount, onMounted } from 'vue'
import { registerCursorTracker } from 'cleave-zen'

const [model, modifiers] = defineModel({
  type: [Number, String],
  default: null,
  set: value => modifiers.number ? Number(value) : value
})

const { options, format, unformat } = defineProps({
  options: { type: Object, default: () => ({}) },
  format: { type: Function, default: value => value },
  unformat: { type: Function, default: value => value }
})

const input = ref()
const tracker = ref()

const handleInputChange = ({ target }) => {
  const value = target.value

  input.value.value = format(value)
  model.value = unformat(value)
}

watch([model, () => options], () => input.value.value = format(model.value))

onMounted(() => {
  input.value.value = format(model.value)

  tracker.value = registerCursorTracker({ input: input.value, ...options })

  input.value.addEventListener('input', handleInputChange)
})

onBeforeUnmount(() => {
  input.value.removeEventListener('input', handleInputChange)
  tracker.value?.()
})
</script>